export default __webpack_public_path__ + "static/media/homescapes@2x.31274eb3.webp";